import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

import StaticCollapseTrigger from 'src/components/ResumeCard/Body/Collapse/Trigger/Static';

const TrlKeys = {
    expand: 'resumeCard.trigger.expand',
    collapse: 'resumeCard.trigger.collapse',
};

interface Props {
    expanded: boolean;
    onToggle: () => void;
    dataQa?: string;
}

const DynamicCollapseTrigger: TranslatedComponent<Props> = ({ expanded, onToggle, dataQa, trls }) => {
    return (
        <StaticCollapseTrigger
            text={trls[expanded ? TrlKeys.collapse : TrlKeys.expand]}
            expanded={expanded}
            onToggle={onToggle}
            dataQa={dataQa}
        />
    );
};

export default translation(DynamicCollapseTrigger);
